import Vue from 'vue';

Vue.filter('filter', (list = [], min, max, sub, color) => {
  const withStock = []
  const withoutStock = []

  // [Bug]
  // For some reason the list is undefined in certain moment of the rendering
  // seems to be at the end of the fetch from the products.
	list.filter(p => {
		let equal_color = false;

		if ((min || max) && sub && color) {
			if (p.color == color) {
				equal_color = true;
			}

			for (let i = 0; i < p.childs.length; i++) {
				if (p.childs[i].color == color) {
					equal_color = true;
					break;
				}
			}

			return p.price >= min && p.price <= max && p.category_id == sub && equal_color;
		}

		if ((min || max) && sub) {
			return p.price >= min && p.price <= max && p.category_id == sub;
		}

		if ((min || max) && color) {
			if (p.color == color) {
				equal_color = true;
			}

			for (let i = 0; i < p.childs.length; i++) {
				if (p.childs[i].color == color) {
					equal_color = true;
					break;
				}
			}

			return p.price >= min && p.price <= max && equal_color;
		}

		if (sub) {
			return p.category_id == sub;
		}

		if (min || max) {
			return p.price >= min && p.price <= max;
		}

		if (color) {
			// Check if the parent has the color.
			if (p.color == color) {
				equal_color = true;
			}

			// Check if the childs has the color.
			for (let i = 0; i < p.childs.length; i++) {
				if (p.childs[i].color == color) {
					equal_color = true;
					break;
				}
			}

			return p.color == equal_color;
		}
	}).forEach(p => {
    if (p.stock) withStock.push(p);
    else withoutStock.unshift(p);
  });

  return [
    ...withStock,
    ...withoutStock,
  ];
});



// WEBPACK FOOTER //
// ./src/filters/filters.js